// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3dlyi","navText":"Navbar_navText__3keWZ","navLogo":"Navbar_navLogo__1kHUQ","imgLogo":"Navbar_imgLogo__wycEb"};